/** Device UI data (dui)
 * @description Store to cache the Device UI (dui) data from the PHP API.
 */

import type { DeviceUI, DeviceUIField, DeviceUIList } from 'src/types/DeviceUI';
import { get, writable } from 'svelte/store';

function create_device_ui() {
	const { subscribe, set, update } = writable<DeviceUIList>(
		JSON.parse(localStorage.getItem('device_ui')) || {},
	);

	return {
		subscribe,
		set,
		getDeviceUI: (device_id: string) => {
			return get(device_ui)?.[device_id] || {};
		},
		getDeviceUIField: (device_id: string, key: string) => {
			let value: any;
			if (get(device_ui).hasOwnProperty(device_id)) {
				value = get(device_ui)[device_id]?.[key];
			}
			return value;
		},

		updateDeviceUIField: (device_id: string, key: DeviceUIField, value: DeviceUI[DeviceUIField]) =>
			update((devices_data) => {
				const new_data = { ...devices_data[device_id], [key]: value };
				return { ...devices_data, [device_id]: new_data };
			}),
		bulkUpdateDeviceUI: (devices_data: DeviceUIList) =>
			update((devices) => {
				const new_data = { ...devices, ...devices_data };
				return new_data;
			}),
		updateDeviceUI: (device_id: string, dui_data: DeviceUI) =>
			update((devices_data) => {
				const new_data = { ...devices_data?.[device_id], ...dui_data };
				return { ...devices_data, [device_id]: new_data };
			}),

		removeDeviceUI: (device_id: string, key: DeviceUIField) =>
			update((devices_data) => {
				delete devices_data[device_id]?.[key];
				return devices_data;
			}),
		removeDevice: (device_id: string) =>
			update((devices_data) => {
				delete devices_data[device_id];
				return devices_data;
			}),
		reset: () => set({}),
	};
}

export const device_ui = create_device_ui();
device_ui.subscribe((val) => {
	localStorage.setItem('device_ui', JSON.stringify(val));
});
